import { render, staticRenderFns } from "./camera_info.vue?vue&type=template&id=6584ebb2&"
import script from "./camera_info.vue?vue&type=script&lang=js&"
export * from "./camera_info.vue?vue&type=script&lang=js&"
import style0 from "./camera_info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports